import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Stack from "@mui/material/Stack";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import { createContext, useContext, useEffect, useState } from "react";
import { useHotkeys } from "react-hotkeys-hook";

const UpAndDownContext = createContext({ values: [] });

export const UpAndDownProvider = ({ children, values, onChange }) => {
  // Keep initial values without updating the list in the up and down component
  const [initialValues] = useState(values);

  return (
    <UpAndDownContext.Provider
      value={{ values: initialValues, onChange: onChange }}
    >
      {children}
    </UpAndDownContext.Provider>
  );
};

export const UpAndDownButton = ({ value, ...props }) => {
  const { values, onChange } = useContext(UpAndDownContext);
  const [index, setIndex] = useState(null);
  useHotkeys(
    "meta+ArrowUp",
    () => {
      if (index >= 1) onChange && onChange(values[index - 1]);
    },
    { preventDefault: true },
  );
  useHotkeys(
    "meta+ArrowDown",
    () => {
      if (index < values.length - 1) onChange && onChange(values[index + 1]);
    },
    { preventDefault: true },
  );

  useEffect(() => {
    if (!values) return setIndex(undefined);
    setIndex(values.indexOf(value));
  }, [values, value]);

  if (!values) {
    return <></>;
  }

  return (
    <Stack {...props} direction="row">
      <Tooltip title="&#8984;+&uarr;">
        <span>
          <IconButton
            onClick={() => onChange && onChange(values[index - 1])}
            disabled={index < 1}
          >
            <ExpandLessIcon />
          </IconButton>
        </span>
      </Tooltip>
      <Tooltip title="&#8984;+&darr;">
        <span>
          <IconButton
            onClick={() => onChange && onChange(values[index + 1])}
            disabled={index >= values.length - 1}
          >
            <ExpandMoreIcon />
          </IconButton>
        </span>
      </Tooltip>
    </Stack>
  );
};
